import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import './Group.scss';

const Group = props => {
  return (
    <section
      className={cx(
        'grid__group',
        `grid__group--desktop-width-${props.desktopWidth}`,
        `grid__group--desktop-gutter-${props.desktopGutter}`,
        `grid__group--desktop-alignment-${props.desktopAlignment}`
      )}>
      <div className="container-guttered">
        <div className="grid__column-wrapper">{props.items}</div>
      </div>
    </section>
  );
};

Group.propTypes = {
  desktopWidth: PropTypes.string.isRequired,
  desktopGutter: PropTypes.string.isRequired,
  desktopAlignment: PropTypes.string.isRequired,
  desktopUp: PropTypes.bool.isRequired,
  items: PropTypes.arrayOf(PropTypes.node.isRequired).isRequired
};

export default Group;



// WEBPACK FOOTER //
// ./src/client/js/view/components/Group/Group.js